import React from 'react';
import { MediaCard } from './Card'
import { minsters, Senior, PMD, candidates } from './data'
import Grid from '@material-ui/core/Grid';


export var AllSelectedCandidates = {};

function IsStringValid(str) {
  try {
    JSON.parse(atob(str));

  } catch (e) {
    return false;
  }
  return true;
}
function getNumber(x, num) {
  try {
    let value = x[num];
    let c = candidates.find((e) => {
      return value === parseInt(e.imageURL)
    })
    return c

  } catch (e) {
    return false;
  }
}

export const OrgChartComponent = ({ candidates }) => {
  let x = null;
  if (IsStringValid(candidates)) {
    x = JSON.parse(atob(candidates));
    console.log(x);
    AllSelectedCandidates = x;
  }


  return (
    <Grid id="TREE" container item justifyContent="center" spacing={1} xs={12}>
      <Grid xs={12} md lg xl={2} key={154} item>
        <MediaCard
          number={1}
          role="Prime Minister"
          selectedCandidateURL={getNumber(x,1)}
        />
      </Grid>
      <Grid xs={12} md={6} lg xl={1} key={12} item>
        <MediaCard
          number={2}
          role="Deputy Prime Minister"
          selectedCandidateURL={getNumber(x,2)}

        />
      </Grid>
      {
        Senior.map((value, index) => (
          <Grid xs={12} md={6} lg xl={1} key={value + index} item>
            <MediaCard
              number={3 + index}
              role={"(Senior) " + value}
              selectedCandidateURL={getNumber(x,3 + index)}
            />
          </Grid>
        ))
      }
      {
        PMD.map((value, index) => (
          <Grid xs={12} md={6} lg xl={1} key={value + index} item>
            <MediaCard
              number={7 + index}
              role={"(PM Department) " + value}
              selectedCandidateURL={getNumber(x,7 + index)}

            />
          </Grid>
        ))
      }

      {minsters.map((value, index) => (
        <Grid xs={12} md={6} lg xl={1} key={value + index} item>
          <MediaCard
            number={12 + index}
            role={value}
            selectedCandidateURL={getNumber(x,12 + index)}

          />
        </Grid>
      ))}
    </Grid>
  )
};